import { RECO_DETAILS_ACTIONS } from "../../actions/recoDetailsActions";
import { cloneObject } from "../../helpers/helper";

const defaultState = {
    fetching : false,
    recoDetails : {}, 
    queryCardLoaded : false
}

const recoDetailsReducer = (state = cloneObject(defaultState), action) => {
    switch(action.type){
        case RECO_DETAILS_ACTIONS.FETCHING_DETAILS : 
            state = {
                ...state,
                fetching : true
            }
        break;
        case RECO_DETAILS_ACTIONS.FETCH_DETAILS_SUCCESS : 
            state = {
                ...state,
                recoDetails : {
                    ...state.recoDetails,
                    [action.payload.recoId] : {
                        details : action.payload.details,
                        metaData : action.payload.metaData
                    }    
                },
                fetching : false
            }
        break;
        case RECO_DETAILS_ACTIONS.FETCH_DETAILS_FAILURE : 
            state = {
                ...state,
                recoDetails : {
                    ...state.recoDetails,
                    [action.payload.recoId] : {
                        failed : true
                    }
                },
                fetching : false
            }
        break;
        case RECO_DETAILS_ACTIONS.QUERY_CARD_LOADED : 
            state = {
                ...state,
                queryCardLoaded : true
            }
        break;    
        default : 
        break;
    }
    return state;
}

export default recoDetailsReducer;